<template>
    <div class="header-analytics-practice">
        <h1 class="header-analytics-practice__heading">Pratik Analitikleri</h1>
        <p class="header-analytics-practice__desc">Ne kadar pratik yaptığını incele.</p>
    </div>
</template>
<script></script>
<style scoped src="@/css/components/header-analytics-practice.css"></style>